import { toNumber } from 'lodash'

const getters = {
    loading: (state) =>  state.loading,
    ccloneList: (state) => state.ccloneList,
    ccloneAvailable: (state) => {
        return state.ccloneList.filter((cclone) => cclone.status === 'available')
    },
    expiringAudiences: (state) => state.expiringAudiences,
    expiringAudiencesError: (state) => state.expiringAudiencesError,
    expiringAudiencesLoading: (state) => state.expiringAudiencesLoading,
    expiringTransfers: (state) => state.expiringTransfers,
    expiringTransfersError: (state) => state.expiringTransfersError,
    expiringTransfersLoading: (state) => state.expiringTransfersLoading,
    breakdownLoading: (state) => state.breakdownLoading,
    isKibanaAllowed: (_state, _getters, rootState) => {
        return (
            process.env.VUE_APP_ALLOWED_KIBANA_ACCOUNTS &&
            JSON.parse(process.env.VUE_APP_ALLOWED_KIBANA_ACCOUNTS).includes(toNumber(rootState.account.accountId))
        )
    },
    affinityBreakdown: (state) => state.affinityBreakdown,
    percentBreakdown: (state) => state.percentBreakdown,
    collectOffline: (state) => state.collectOffline,
    collectOfflineLoading: (state) => state.collectOfflineLoading,
    collectOnline: (state) => state.collectOnline,
    collectOnlineLoading: (state) => state.collectOnlineLoading,
    taxonomiesBreakdownAffinity: (state) => state.taxonomiesBreakdownAffinity,
    taxonomiesBreakdownPurcent: (state) => state.taxonomiesBreakdownPurcent,
    taxonomiesBreakdownLoading: (state) => state.taxonomiesBreakdownLoading,
    volumes: (state) => state.volumes,
    volumesError: (state) => {
        return state.volumesError
    },
    loadingVolumesToken: (state) => {
        return state.loadingVolumesToken
    },
    loadingTaxonomyBreakdownToken: (state) => {
        return state.loadingTaxonomyBreakdownToken
    },
    loadingVolumes: (state) => {
        return state.loadingVolumes
    }
}

export default getters